import React, { FC, useCallback, useState } from 'react';

import Button, { BUTTON_SIZES } from 'buyside/components/presentation/Button/button';
import Modal from 'buyside/components/presentation/Modal/modal';

import MessageBubbleIcon from 'buyside/svgs/message_bubble.svg';

const PaladinReviewModal: FC<{
  buttonText?: string;
  description: string;
}> = ({ buttonText, description }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        icon={MessageBubbleIcon}
        onClick={() => setIsModalOpen(true)}
        size={BUTTON_SIZES.TINY}
        text={buttonText}
      />
    ),
    [buttonText]
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      title="Paladin Review"
    >
      <p>{description}</p>
    </Modal>
  );
};

export default PaladinReviewModal;
